
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import useAppState from '@/composables/ui/ui'
import usePostCreate from '@/composables/post/postCreate'

export default defineComponent({
  name: 'PostSaved',
  components: {
    AButton,
  },
  setup() {
    const { lastSavedPost } = useAppState()
    const { showAfterCreate } = usePostCreate()

    const close = () => {
      const { showLastSavedPost } = useAppState()
      showLastSavedPost.value = false
    }

    return {
      lastSavedPost,
      showAfterCreate,
      close,
    }
  },
})
